<template>
  <div class="container-protecao">
   <router-view />
  </div>
</template>

<script>
export default {  
  mounted(){
     document.documentElement.scrollTop = 0;
  }
}
</script>

<style>
.painel{
  background-image: url('/revisorPisCofins/img/banerP.svg') ;  
  background-repeat: no-repeat;
  position: relative;
 background-size: 100%;
 height:357px;
  width: 100%;
  max-height: 415px;
  display: flex;
  align-items: center;
  padding-bottom:5%;
  justify-content: center;
}
.container-protecao{
  width: 100%;
  max-width: 1300px;
  margin:0 auto;
  background:#fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}







</style>